'use strict';

var chunkWCZVW4FH_js = require('./chunk-WCZVW4FH.js');
var chunkR7NM4BVL_js = require('./chunk-R7NM4BVL.js');
var chunkHBLUB7JI_js = require('./chunk-HBLUB7JI.js');
var luxon = require('luxon');
var countries = require('countries-phone-masks');

function _interopDefault (e) { return e && e.__esModule ? e : { default: e }; }

var countries__default = /*#__PURE__*/_interopDefault(countries);

// ../types/dist/index.mjs
var Webhook_Event_Enum = /* @__PURE__ */ ((Webhook_Event_Enum2) => {
  Webhook_Event_Enum2["USER_CREATED"] = "USER_CREATED";
  Webhook_Event_Enum2["USER_UPDATED"] = "USER_UPDATED";
  Webhook_Event_Enum2["USER_DELETED"] = "USER_DELETED";
  Webhook_Event_Enum2["PROFILE_CREATED"] = "PROFILE_CREATED";
  Webhook_Event_Enum2["PROFILE_UPDATED"] = "PROFILE_UPDATED";
  Webhook_Event_Enum2["PROFILE_DELETED"] = "PROFILE_DELETED";
  Webhook_Event_Enum2["CLIENT_CREATED"] = "CLIENT_CREATED";
  Webhook_Event_Enum2["CLIENT_UPDATED"] = "CLIENT_UPDATED";
  Webhook_Event_Enum2["CLIENT_DELETED"] = "CLIENT_DELETED";
  Webhook_Event_Enum2["CLIENT_ADDRESS_CREATED"] = "CLIENT_ADDRESS_CREATED";
  Webhook_Event_Enum2["CLIENT_ADDRESS_UPDATED"] = "CLIENT_ADDRESS_UPDATED";
  Webhook_Event_Enum2["CLIENT_ADDRESS_DELETED"] = "CLIENT_ADDRESS_DELETED";
  Webhook_Event_Enum2["CART_CREATED"] = "CART_CREATED";
  Webhook_Event_Enum2["CART_UPDATED"] = "CART_UPDATED";
  Webhook_Event_Enum2["CART_DELETED"] = "CART_DELETED";
  return Webhook_Event_Enum2;
})(Webhook_Event_Enum || {});
Object.values(
  Webhook_Event_Enum
).map((key) => key);
var NineNineFoodOrderStatus = {
  // Order created
  ORDER_ACCEPTED: 200,
  // Order accepted (The store sent confirmation)
  RIDER_TOOK_ORDER: 400,
  // The rider arrived at the customer's location
  ORDER_FINISHED: 600,
  // Order finished, completed
  READY_FOR_PICKUP: 1e3,
  // Order ready for pickup
  // Status de cancelamento
  CANCELLED_BY_CUSTOMER_1: 901,
  // Cancellation -- Cancelled by the customer
  CANCELLED_BY_CUSTOMER_2: 902,
  // Cancellation -- Cancelled by the store due to timeout (Not confirmed order acceptance within the permitted timeframe)
  CANCELLED_BY_STORE_1: 921,
  // Cancellation -- Cancelled by the store (after receiving the order)
  CANCELLED_BY_STORE_2: 923,
  // Cancellation -- Cancelled by the store (after receiving the order)
  CANCELLED_BY_99FOOD_SERVICE: 961,
  // Cancellation -- Cancelled by 99Food customer service due to request of the customer
  CANCELLED_BY_COURIER_1: 971,
  // Cancellation -- Cancelled by courier
  CANCELLED_BY_COURIER_2: 981
  // Cancellation -- Cancelled by courier
};
var DELIVERY_LABELS = {
  "pt-BR": {
    pickup_the_location: "Retirar no local",
    table_request: "Pedido na mesa",
    eat_here: "Comer aqui"
  },
  "en-US": {
    pickup_the_location: "Pick up at location",
    table_request: "Table order",
    eat_here: "Eat here"
  }
};
var translateDeliveryLabel = (key, language) => {
  const normalizedLanguage = language && DELIVERY_LABELS[language] ? language : "pt-BR";
  return DELIVERY_LABELS[normalizedLanguage][key];
};
var Cart = class _Cart {
  id;
  slug;
  profileId;
  clientId;
  client;
  addressId;
  address;
  cupomId;
  cupom;
  commandId;
  command;
  bartenderId;
  bartender;
  cashierId;
  cashier;
  motoboyId;
  motoboy;
  secretNumber;
  code;
  status;
  obs;
  type;
  taxDelivery;
  timeDelivery;
  formsPayment;
  statusPayment;
  print;
  tentatives;
  total;
  totalPaid;
  controls;
  packageDate;
  created_at;
  updated_at;
  itens;
  origin;
  ifoodStatus;
  ifoodAditionalInfo;
  taxIfood;
  orderId;
  fees;
  defaultStatusProductionPackage = "Ol\xE1 [NOME], seu pedido foi recebido.";
  defaultStatusProductionMessage = "Ol\xE1 [NOME], seu pedido est\xE1 em produ\xE7\xE3o.";
  defaultStatusToRemoveMessage = "Obaaa [NOME], seu pedido est\xE1 pronto para retirada.";
  defaultStatusTransportMessage = "Obaaa [NOME], seu pedido est\xE1 a caminho.";
  defaultCanceledMessage = "Ol\xE1 [NOME], seu pedido foi cancelado.";
  sendMB = false;
  constructor({
    id,
    slug,
    addressId,
    address,
    bartenderId,
    bartender,
    cashierId,
    cashier,
    clientId,
    client,
    motoboyId,
    motoboy,
    commandId,
    command,
    cupomId,
    profileId,
    controls,
    formsPayment,
    itens,
    obs,
    secretNumber,
    code,
    status,
    taxDelivery,
    type,
    statusPayment,
    timeDelivery,
    total,
    totalPaid,
    print,
    tentatives,
    created_at,
    updated_at,
    packageDate,
    cupom,
    origin = "whatsmenu",
    taxIfood,
    orderId,
    ifoodStatus,
    ifoodAditionalInfo,
    fees
  }) {
    this.id = id;
    this.slug = slug;
    this.addressId = addressId;
    this.address = address;
    this.bartenderId = bartenderId;
    this.bartender = bartender;
    this.cashierId = cashierId;
    this.cashier = cashier;
    this.clientId = clientId;
    this.client = client;
    this.motoboyId = motoboyId;
    this.motoboy = motoboy;
    this.commandId = commandId;
    this.command = command ? new Command(command) : void 0;
    this.cupomId = cupomId;
    this.cupom = cupom;
    this.profileId = profileId;
    this.controls = controls;
    this.formsPayment = formsPayment;
    this.itens = itens ? itens.map((item) => new chunkR7NM4BVL_js.CartItem(item, code)) : [];
    this.obs = obs;
    this.secretNumber = secretNumber;
    this.code = code;
    this.status = status;
    this.taxDelivery = taxDelivery;
    this.type = type;
    this.timeDelivery = timeDelivery;
    this.total = total;
    this.totalPaid = totalPaid;
    this.print = print;
    this.tentatives = tentatives;
    this.statusPayment = statusPayment;
    this.created_at = created_at;
    this.updated_at = updated_at;
    this.packageDate = packageDate;
    this.origin = origin;
    this.ifoodStatus = ifoodStatus;
    this.ifoodAditionalInfo = ifoodAditionalInfo;
    this.taxIfood = taxIfood;
    this.orderId = orderId;
    this.fees = fees;
  }
  applyMask(mask, value) {
    let i = 0;
    const digits = value.replace(/\D/g, "");
    return mask.replace(/#/g, () => digits[i++] ?? "");
  }
  returnMaskedContact() {
    if (this.type === "T") {
      return "-";
    }
    if (this.client) {
      if (this.client.controls?.iso) {
        const countryIso = this.client.controls.iso;
        const selectedCountry = countries__default.default.find((country) => country.iso === countryIso);
        let mask;
        if (Array.isArray(selectedCountry?.mask)) {
          mask = selectedCountry.mask.find((m) => m.replaceAll("#", "0").replace(/\D/g, "").length === this.client.whatsapp.length);
        } else {
          mask = selectedCountry?.mask;
        }
        if (mask) {
          const formatted = this.applyMask(mask, this.client.whatsapp);
          return formatted;
        }
      }
      if (this.client.whatsapp.length > 10) {
        return this.client.whatsapp.replace(
          /(\d{2})(\d{5})(\d{4})/,
          "($1) $2-$3"
        );
      }
      return this.client.whatsapp.replace(
        /(\d{2})(\d{4})(\d{4})/,
        "($1) $2-$3"
      );
    }
  }
  getTotalComplements() {
    return this.itens.filter((item) => !Boolean(item.deleted_at)).filter((i) => i.type === "pizza").flatMap((i) => i.details.complements.flatMap((c) => c.itens)).reduce((total, item) => total += item.value * (item.quantity || 1), 0);
  }
  date() {
    let formatted;
    if (this.origin === "ifood") {
      formatted = `${luxon.DateTime.fromISO(this.packageDate, { setZone: true }).toFormat("dd/MM/yyyy")} ${luxon.DateTime.fromISO(this.packageDate, { setZone: true }).toFormat("ss").includes("01") ? "(SH)" : luxon.DateTime.fromISO(this.packageDate, { setZone: true }).toFormat(
        "HH:mm"
      )}`;
    }
    if (this.origin !== "ifood") {
      formatted = `${luxon.DateTime.fromSQL(this.packageDate, { setZone: true }).toFormat("dd/MM/yyyy")} ${luxon.DateTime.fromSQL(this.packageDate, { setZone: true }).toFormat("ss").includes("01") ? "(SH)" : luxon.DateTime.fromSQL(this.packageDate, { setZone: true }).toFormat(
        "HH:mm"
      )}`;
    }
    return {
      date: this.packageDate,
      onlyDate: luxon.DateTime.fromSQL(this.packageDate, { setZone: true }).toFormat(
        "dd/MM/yyyy"
      ),
      zero: luxon.DateTime.fromSQL(this.packageDate, { setZone: true }).set({
        hour: 0,
        minute: 0,
        second: 0,
        millisecond: 0
      }),
      formatted
    };
  }
  transshipment() {
    return this.formsPayment.reduce(
      (total, formPayment) => total += formPayment.payment === "money" ? Number(formPayment.change) ?? 0 : 0,
      0
    );
  }
  typeDeliveryText(textPackage = "Encomendas", textOnly = false, language) {
    let textDelivery = "";
    switch (this.type) {
      case "D":
        textDelivery = this.address && !textOnly ? `**Delivery**
\r` : `**${translateDeliveryLabel("pickup_the_location", language)}**`;
        break;
      case "P":
        textDelivery = this.address && !textOnly ? `**${textPackage}**\r
` : `**${translateDeliveryLabel("pickup_the_location", language)}**`;
        break;
      case "T":
        textDelivery = `**${translateDeliveryLabel("table_request", language)}**`;
        break;
      case "L":
        textDelivery = `**${translateDeliveryLabel("eat_here", language)}**`;
        break;
    }
    return textDelivery;
  }
  getTextTypeReq() {
    return this.type;
  }
  /**
   * Retorna o nome do cliente baseado no tipo do carrinho.
   *
   * @returns {string} nome do cliente ou comanda
   */
  nameClient = () => {
    switch (this.type) {
      case "T":
        return `${this.command?.name}`;
      case "D":
        return `${this.client ? `${this.client.name} ${this.client.last_name ? this.client.last_name : ""}` : "Sem cadastro"}`;
      case "P":
        return `${this.client ? `${this.client.name} ${this.client.last_name ? this.client.last_name : ""}` : "Sem cadastro"}`;
      default:
        return "Sem cadastro";
    }
  };
  getTotalValue(sumWith) {
    let total = this.total;
    let fees;
    let feesValue = 0;
    if (this?.fees) {
      fees = this?.fees;
      if (typeof fees === "string") {
        do {
          fees = JSON.parse(fees);
        } while (typeof fees === "string");
      }
      feesValue = fees.reduce(
        (acc, fee) => {
          if (!fee.automatic) return acc;
          if (fee.type === "percent") {
            return acc + total * (fee.value / 100);
          }
          return acc + fee.value;
        },
        0
      );
    }
    const stripeFee = Number(this.controls?.stripe?.fee || 0);
    feesValue += stripeFee;
    const asaasPixFee = Number(this.controls?.asaas?.pixFee || 0);
    const asaasCreditFee = Number(this.controls?.asaas?.creditFee || 0);
    feesValue += asaasPixFee + asaasCreditFee;
    if (this.taxIfood && sumWith === "total") {
      total += this.taxIfood;
    }
    const cashbackValue = chunkWCZVW4FH_js.jsonSerialize(this.formsPayment).filter((form) => form.payment === "cashback").reduce(
      (acc, form) => acc + Math.abs(Number(form.value) || 0),
      0
    );
    const totalCart = total + this.taxDelivery - this.calcCupomValue() - cashbackValue;
    let addonTotal = 0;
    if (this.formsPayment && this.formsPayment.length > 0) {
      addonTotal = this.formsPayment.reduce((total2, form) => {
        if (form.paymentId) return total2;
        let currentAddon = 0;
        if (typeof form.addonValue === "number") {
          currentAddon = form.addonValue;
        } else if (form.addon && form.addon.status) {
          const {
            type: addonType,
            value: addonValue,
            valueType: addonValueType
          } = form.addon;
          if (addonValueType === "percentage") {
            currentAddon = Number((addonValue / 100 * (totalCart || 0)).toFixed(2));
          } else if (addonValueType === "fixed") {
            currentAddon = addonValue;
          }
          if (addonType === "discount") {
            currentAddon = currentAddon * -1;
          }
        }
        return total2 + currentAddon;
      }, 0);
    }
    const totalResult = total + this.taxDelivery - this.calcCupomValue() + addonTotal;
    switch (sumWith) {
      case "subtotal":
        return total;
      case "total":
        if (cashbackValue > totalResult + feesValue) {
          return 0;
        }
        return totalResult - cashbackValue + feesValue;
      case "lack":
        return Number(
          Math.fround(
            total + this.taxDelivery - Math.max(
              this.formsPayment.reduce(
                (total2, formPayment) => total2 += formPayment.value,
                0
              ),
              0
            ) + addonTotal
          ).toFixed(2)
        );
      case "addon":
        return addonTotal;
      case "paid":
        return this.formsPayment?.reduce(
          (total2, formPayment) => total2 += formPayment.value,
          0
        ) || 0;
      case "cashback":
        return cashbackValue;
      case "fees":
        return feesValue;
    }
  }
  /**
   * Calcula o valor total dos itens cancelados.
   *
   * @return {number}
   */
  totalItemsCancelled() {
    return this.itens.filter((item) => Boolean(item.deleted_at)).reduce((total, i) => total += i.details.value * i.quantity, 0);
  }
  /**
   * Calcula o valor do cupom com base em seu tipo.
   *
   * @return {number}
   */
  calcCupomValue() {
    let cupomValue = 0;
    if (this.cupom) {
      switch (this.cupom.type) {
        case "percent":
          cupomValue = this.total * (Number(this.cupom.value) / 100);
          break;
        case "value":
          cupomValue = Number(this.cupom.value);
          break;
        case "freight":
          cupomValue = this.taxDelivery;
      }
    }
    return cupomValue;
  }
  static calcValuePizza(pizza, onlyPizza = false) {
    if (onlyPizza) {
      const totalImplementations = pizza.details.implementations.reduce(
        (total, implementation) => total += implementation.value,
        0
      );
      return pizza.details.value - totalImplementations;
    }
    return pizza.details.value * pizza.quantity;
  }
  permenance(report, opened = this.command?.opened) {
    let permenance;
    if (!opened) {
      return permenance;
    }
    const tableOpenDate = report ? luxon.DateTime.fromISO(opened.created_at).toFormat("HH:mm") : luxon.DateTime.fromSQL(opened.created_at).toFormat("HH:mm");
    const tableCloseDate = report ? luxon.DateTime.fromISO(opened.updated_at).toFormat("HH:mm") : luxon.DateTime.local().toFormat("HH:mm");
    const perm = report ? luxon.DateTime.fromISO(opened.updated_at).diff(luxon.DateTime.fromISO(opened.created_at), [
      "hours",
      "minutes"
    ]).toFormat("hh'h'mm") : luxon.DateTime.local().diff(luxon.DateTime.fromSQL(opened.created_at), [
      "hours",
      "minutes"
    ]).toFormat("hh'h'mm");
    return permenance = `${tableOpenDate}/${tableCloseDate} ${perm}`;
  }
  /**
   * Procura em `pool` um item agrupável com `cartItem` (fonte única das regras de igualdade).
   * Só agrupa itens ativos (sem deleted_at) e sem observação, do mesmo tipo,
   * mesmo valor unitário e complementos iguais. Pizza: mesmo tamanho, sabores e implementações.
   */
  static findGroupableItem(pool, cartItem) {
    if (cartItem.obs || cartItem.deleted_at) return void 0;
    return pool.find((item) => {
      if (item.obs || item.deleted_at || item.type !== cartItem.type) {
        return false;
      }
      switch (cartItem.type) {
        case "default":
          return item.productId === cartItem.productId && item.name === cartItem.name && item.details.value === cartItem.details.value && item.details.complements.length === cartItem.details.complements.length && chunkHBLUB7JI_js.Complement.verifyEqualsComplements(
            item.details.complements,
            cartItem.details.complements
          );
        case "pizza":
          return item.pizzaId === cartItem.pizzaId && item.details.value === cartItem.details.value && item.details.sizeCode === cartItem.details.sizeCode && item.details.flavors.length === cartItem.details.flavors.length && item.details.implementations.length === cartItem.details.implementations.length && item.details.complements.length === cartItem.details.complements.length && item.details.flavors.every(
            (pizzaFlavor) => cartItem.details.flavors?.some(
              (elPizzaFlavor) => elPizzaFlavor.code === pizzaFlavor.code
            )
          ) && cartItem.details.flavors?.every(
            (pizzaFlavor) => item.details.flavors?.some(
              (elPizzaFlavor) => elPizzaFlavor.code === pizzaFlavor.code
            )
          ) && item.details.implementations?.every(
            (pizzaImplementation) => cartItem.details?.implementations.some(
              (elPizzaImplementation) => elPizzaImplementation.code === pizzaImplementation.code
            )
          ) && chunkHBLUB7JI_js.Complement.verifyEqualsComplements(
            item.details.complements,
            cartItem.details.complements
          );
        default:
          return false;
      }
    });
  }
  groupItens = (groupItems) => {
    return this.itens.reduce((newItems, cartItem) => {
      const groupable = groupItems ? _Cart.findGroupableItem(newItems, cartItem) : void 0;
      if (groupable) {
        groupable.quantity += cartItem.quantity;
      } else {
        newItems.push(new chunkR7NM4BVL_js.CartItem(cartItem, this.code));
      }
      return newItems;
    }, []);
  };
  /**
   * Agrupa itens iguais de vários carts numa lista única, sem separar por pedido.
   * Usa o `groupItens` de cada instância (respeita overrides, ex.: desktop).
   * Itens de carts cancelados não mesclam. Só altera as cópias devolvidas,
   * então os totais dos carts/comanda/mesa não mudam.
   */
  static groupItensFromCarts(carts, groupItems) {
    const items = [];
    const pool = [];
    carts.forEach((cart) => {
      const cartItems = cart.groupItens(groupItems);
      if (!groupItems || cart.status === "canceled") {
        items.push(...cartItems);
        return;
      }
      cartItems.forEach((item) => {
        const groupable = _Cart.findGroupableItem(pool, item);
        if (groupable) {
          groupable.quantity += item.quantity;
        } else {
          items.push(item);
          pool.push(item);
        }
      });
    });
    return items;
  }
  groupItensFromCarts = (carts, groupItems) => _Cart.groupItensFromCarts(carts, groupItems);
  async setMotoboyId(id, callback) {
    this.motoboyId = id;
    callback();
  }
  formatedAddress() {
    if (!this.address) {
      return "";
    }
    const formatZipcode = (zipcode) => {
      if (!zipcode && zipcode !== 0) return "";
      const digits = String(zipcode).replace(/\D/g, "");
      if (!digits) return "";
      if (digits.length === 8)
        return `${digits.slice(0, 5)}-${digits.slice(5)}`;
      if (digits.length <= 5) return digits;
      return `${digits.slice(0, digits.length - 3)}-${digits.slice(-3)}`;
    };
    return `${this.address?.street || ""}, ${this.address?.number || ""} ${this.address?.complement || ""}, ${this.address?.reference || ""} - ${this.address?.neighborhood || ""}, ${this.address?.city || ""} - ${this.address?.uf || ""}, ${formatZipcode(this.address?.zipcode)}`;
  }
  static cartPrint() {
    const cartPrintTest = {
      id: 7054262,
      profileId: 1,
      clientId: 56,
      statusPayment: "paid",
      addressId: 616476,
      code: "999",
      status: null,
      taxIfood: 0,
      obs: null,
      type: "D",
      taxDelivery: 5,
      timeDelivery: "10",
      formsPayment: [
        {
          flags: [],
          label: "Dinheiro",
          value: 169.5,
          status: true,
          payment: "money",
          addon: {
            status: true,
            type: "fee",
            valueType: "percentage",
            value: 10
          }
        }
      ],
      print: 1,
      tentatives: 0,
      total: 164.5,
      controls: {
        ifood: {},
        grovenfe: {
          fiscal_note: {}
        }
      },
      packageDate: null,
      created_at: "2023-07-19 14:58:54",
      updated_at: "2023-07-19 15:08:03",
      itens: [
        {
          id: 1864844,
          cartId: 7054262,
          productId: null,
          pizzaId: 1679,
          type: "pizza",
          quantity: 1,
          obs: "",
          details: {
            value: 44,
            flavors: [
              {
                code: "53e5e0",
                name: "Atum",
                image: "https://s3.us-west-2.amazonaws.com/whatsmenu/production/restaurantbrazil/pizza-products/53e5e0/4.jpg",
                status: true,
                values: {
                  Broto: 15,
                  Grande: 30
                },
                complements: [],
                description: "Molho, mussarela, atum, or\xE9gano e azeitonas",
                valuesTable: {
                  Broto: 15,
                  Grande: 30
                },
                implementations: []
              },
              {
                code: "a0b3c5",
                name: "Frango com Catupiry",
                image: "https://s3.us-west-2.amazonaws.com/whatsmenu/production/restaurantbrazil/pizza-products/a0b3c5/4.jpeg",
                status: true,
                values: {
                  Broto: 22,
                  Grande: 44
                },
                complements: [],
                description: "Molho, mussarela, frango, catupiry original, or\xE9gano e azeitonas",
                valuesTable: {
                  Broto: 22,
                  Grande: 44
                },
                implementations: []
              }
            ],
            complements: [],
            implementations: [
              {
                code: "cf2e08",
                name: "Borda de Catupiry",
                value: 5,
                status: true
              }
            ]
          },
          name: "Pizza Grande 2 Sabores Atum,Frango com Catupiry com Borda de Catupiry",
          controls: {},
          deleted_at: null,
          created_at: "2023-07-19 14:58:54",
          updated_at: "2023-07-19 14:58:54"
        },
        {
          id: 1864845,
          cartId: 7054262,
          productId: null,
          pizzaId: 1679,
          type: "pizza",
          quantity: 1,
          obs: "",
          details: {
            value: 44,
            flavors: [
              {
                code: "a0b3c5",
                name: "Frango com Catupiry",
                image: "https://s3.us-west-2.amazonaws.com/whatsmenu/production/restaurantbrazil/pizza-products/a0b3c5/4.jpeg",
                status: true,
                values: {
                  Broto: 22,
                  Grande: 44
                },
                complements: [],
                description: "Molho, mussarela, frango, catupiry original, or\xE9gano e azeitonas",
                valuesTable: {
                  Broto: 22,
                  Grande: 44
                },
                implementations: []
              },
              {
                code: "53e5e0",
                name: "Atum",
                image: "https://s3.us-west-2.amazonaws.com/whatsmenu/production/restaurantbrazil/pizza-products/53e5e0/4.jpg",
                status: true,
                values: {
                  Broto: 15,
                  Grande: 30
                },
                complements: [],
                description: "Molho, mussarela, atum, or\xE9gano e azeitonas",
                valuesTable: {
                  Broto: 15,
                  Grande: 30
                },
                implementations: []
              }
            ],
            complements: [],
            implementations: [
              {
                code: "cf2e08",
                name: "Borda de Catupiry",
                value: 5,
                status: true
              }
            ]
          },
          name: "Pizza Grande 2 Sabores Frango com Catupiry,Atum com Borda de Catupiry",
          controls: {},
          deleted_at: null,
          created_at: "2023-07-19 14:58:54",
          updated_at: "2023-07-19 14:58:54"
        },
        {
          id: 1864846,
          cartId: 7054262,
          productId: 120101,
          pizzaId: null,
          type: "default",
          quantity: 1,
          obs: "",
          details: {
            value: 11.9,
            isPromote: true,
            complements: [],
            implementations: [],
            flavors: []
          },
          name: "X-Salada",
          controls: {},
          deleted_at: null,
          created_at: "2023-07-19 14:58:54",
          updated_at: "2023-07-19 14:58:54"
        },
        {
          id: 1864847,
          cartId: 7054262,
          productId: 120101,
          pizzaId: null,
          type: "default",
          quantity: 2,
          obs: "",
          details: {
            value: 11.9,
            isPromote: true,
            complements: [],
            implementations: [],
            flavors: []
          },
          name: "X-Salada",
          controls: {},
          deleted_at: null,
          created_at: "2023-07-19 14:58:54",
          updated_at: "2023-07-19 14:58:54"
        },
        {
          id: 1864848,
          cartId: 7054262,
          productId: 120101,
          pizzaId: null,
          type: "default",
          quantity: 1,
          obs: "",
          details: {
            value: 11.9,
            isPromote: true,
            complements: [
              {
                id: 1,
                max: 10,
                min: 0,
                name: "Turbine seu Lanche",
                itens: [
                  {
                    code: "40df65",
                    name: "carne extra",
                    value: 5,
                    status: true,
                    quantity: 1,
                    description: ""
                  },
                  {
                    code: "ce5251",
                    name: "bacon",
                    value: 2,
                    status: true,
                    quantity: 1,
                    description: ""
                  }
                ],
                required: false,
                type: "default",
                order: 0
              }
            ],
            flavors: [],
            implementations: []
          },
          name: "X-Salada",
          controls: {},
          deleted_at: null,
          created_at: "2023-07-19 14:58:54",
          updated_at: "2023-07-19 14:58:54"
        },
        {
          id: 1864849,
          cartId: 7054262,
          productId: 120101,
          pizzaId: null,
          type: "default",
          quantity: 1,
          obs: "Sem tomate, por favor",
          details: {
            value: 11.9,
            isPromote: true,
            complements: [],
            implementations: [],
            flavors: []
          },
          name: "X-Salada",
          controls: {},
          deleted_at: null,
          created_at: "2023-07-19 14:58:54",
          updated_at: "2023-07-19 14:58:54"
        }
      ],
      address: {
        id: 616476,
        clientId: 56,
        street: "Rua Teste",
        number: 100,
        zipcode: null,
        complement: "AP 101",
        reference: "",
        uf: "SP",
        city: "Teste",
        neighborhood: "Bairro Teste 1",
        latitude: null,
        longitude: null,
        distance: 199288,
        controls: {},
        deleted_at: null,
        created_at: "2023-07-19 14:08:31",
        updated_at: "2023-07-19 14:08:31"
      },
      client: {
        id: 56,
        profileId: 1,
        name: "WhatsMenu",
        whatsapp: "99999999999",
        secretNumber: null,
        email: null,
        birthday_date: null,
        last_requests: [
          {
            id: 7054262,
            cart: [
              {
                obs: "",
                name: "X-Salada",
                type: "default",
                details: {
                  value: 11.9,
                  isPromote: true,
                  complements: []
                },
                quantity: 1,
                productId: 120101
              },
              {
                obs: "",
                name: "X-Salada",
                type: "default",
                details: {
                  value: 11.9,
                  isPromote: true,
                  complements: []
                },
                quantity: 2,
                productId: 120101
              },
              {
                obs: "",
                name: "X-Salada",
                type: "default",
                details: {
                  value: 11.9,
                  isPromote: true,
                  complements: [
                    {
                      id: 1,
                      max: 10,
                      min: 0,
                      name: "Turbine seu Lanche",
                      itens: [
                        {
                          code: "40df65",
                          name: "carne extra",
                          value: 5,
                          status: true,
                          quantity: 1,
                          description: ""
                        },
                        {
                          code: "ce5251",
                          name: "bacon",
                          value: 2,
                          status: true,
                          quantity: 1,
                          description: ""
                        }
                      ],
                      required: 0
                    }
                  ]
                },
                quantity: 1,
                productId: 120101
              },
              {
                obs: "Sem tomate, por favor",
                name: "X-Salada",
                type: "default",
                details: {
                  value: 11.9,
                  isPromote: true,
                  complements: []
                },
                quantity: 1,
                productId: 120101
              }
            ],
            code: 7095,
            type: "D",
            total: 164.5,
            status: null,
            cupomId: null,
            clientId: 56,
            controls: {},
            addressId: 616476,
            cartPizza: [
              {
                obs: "",
                name: "Pizza Grande 2 Sabores Atum,Frango com Catupiry com Borda de Catupiry",
                type: "pizza",
                details: {
                  value: 44,
                  flavors: [
                    {
                      code: "53e5e0",
                      name: "Atum",
                      image: "https://s3.us-west-2.amazonaws.com/whatsmenu/production/restaurantbrazil/pizza-products/53e5e0/4.jpg",
                      status: true,
                      values: {
                        Broto: 15,
                        Grande: 30
                      },
                      schedule: {
                        type: 0
                      },
                      complements: [],
                      description: "Molho, mussarela, atum, or\xE9gano e azeitonas",
                      valuesTable: {
                        Broto: 15,
                        Grande: 30
                      },
                      disponibility: {
                        store: "full"
                      },
                      implementations: []
                    },
                    {
                      code: "a0b3c5",
                      name: "Frango com Catupiry",
                      image: "https://s3.us-west-2.amazonaws.com/whatsmenu/production/restaurantbrazil/pizza-products/a0b3c5/4.jpeg",
                      status: true,
                      values: {
                        Broto: 22,
                        Grande: 44
                      },
                      schedule: {
                        type: 0
                      },
                      complements: [],
                      description: "Molho, mussarela, frango, catupiry original, or\xE9gano e azeitonas",
                      valuesTable: {
                        Broto: 22,
                        Grande: 44
                      },
                      disponibility: {
                        store: "full"
                      },
                      implementations: []
                    }
                  ],
                  sizeCode: "4a248f",
                  complements: [],
                  implementations: [
                    {
                      code: "cf2e08",
                      name: "Borda de Catupiry",
                      value: 5,
                      status: true
                    }
                  ]
                },
                pizzaId: 1679,
                quantity: 1
              },
              {
                obs: "",
                name: "Pizza Grande 2 Sabores Frango com Catupiry,Atum com Borda de Catupiry",
                type: "pizza",
                details: {
                  value: 44,
                  flavors: [
                    {
                      code: "a0b3c5",
                      name: "Frango com Catupiry",
                      image: "https://s3.us-west-2.amazonaws.com/whatsmenu/production/restaurantbrazil/pizza-products/a0b3c5/4.jpeg",
                      status: true,
                      values: {
                        Broto: 22,
                        Grande: 44
                      },
                      schedule: {
                        type: 0
                      },
                      complements: [],
                      description: "Molho, mussarela, frango, catupiry original, or\xE9gano e azeitonas",
                      valuesTable: {
                        Broto: 22,
                        Grande: 44
                      },
                      disponibility: {
                        store: "full"
                      },
                      implementations: []
                    },
                    {
                      code: "53e5e0",
                      name: "Atum",
                      image: "https://s3.us-west-2.amazonaws.com/whatsmenu/production/restaurantbrazil/pizza-products/53e5e0/4.jpg",
                      status: true,
                      values: {
                        Broto: 15,
                        Grande: 30
                      },
                      schedule: {
                        type: 0
                      },
                      complements: [],
                      description: "Molho, mussarela, atum, or\xE9gano e azeitonas",
                      valuesTable: {
                        Broto: 15,
                        Grande: 30
                      },
                      disponibility: {
                        store: "full"
                      },
                      implementations: []
                    }
                  ],
                  sizeCode: "4a248f",
                  complements: [],
                  implementations: [
                    {
                      code: "cf2e08",
                      name: "Borda de Catupiry",
                      value: 5,
                      status: true
                    }
                  ]
                },
                pizzaId: 1679,
                quantity: 1
              }
            ],
            cashierId: null,
            commandId: null,
            profileId: 1,
            created_at: "2023-07-19 14:58:54",
            updated_at: "2023-07-19 14:58:54",
            packageDate: null,
            taxDelivery: 5,
            timeDelivery: "10"
          },
          {
            id: 7054261,
            cart: [
              {
                obs: "",
                name: "X-Bacon",
                type: "default",
                details: {
                  value: 9.9,
                  isPromote: true,
                  complements: []
                },
                quantity: 3,
                productId: 23267
              },
              {
                obs: "",
                name: "X-Tudo",
                type: "default",
                details: {
                  value: 9.9,
                  isPromote: true,
                  complements: []
                },
                quantity: 1,
                productId: 23268
              }
            ],
            code: 7094,
            type: "D",
            total: 39.6,
            status: null,
            cupomId: null,
            clientId: 56,
            controls: {},
            addressId: null,
            cartPizza: [],
            cashierId: null,
            commandId: null,
            profileId: 1,
            created_at: "2023-07-19 14:49:00",
            updated_at: "2023-07-19 14:49:00",
            packageDate: null,
            taxDelivery: 0,
            timeDelivery: 0
          },
          {
            id: 7054260,
            cart: [
              {
                obs: "",
                name: "X-Bacon",
                type: "default",
                details: {
                  value: 9.9,
                  isPromote: true,
                  complements: []
                },
                quantity: 3,
                productId: 23267
              },
              {
                obs: "",
                name: "X-Tudo",
                type: "default",
                details: {
                  value: 9.9,
                  isPromote: true,
                  complements: []
                },
                quantity: 1,
                productId: 23268
              }
            ],
            code: 7093,
            type: "D",
            total: 39.6,
            status: null,
            cupomId: null,
            clientId: 56,
            controls: {},
            addressId: 616476,
            cartPizza: [],
            cashierId: null,
            commandId: null,
            profileId: 1,
            created_at: "2023-07-19 14:35:30",
            updated_at: "2023-07-19 14:35:30",
            packageDate: null,
            taxDelivery: 5,
            timeDelivery: "10"
          },
          {
            id: 7054259,
            cart: [
              {
                obs: "",
                name: "X-Bacon",
                type: "default",
                details: {
                  value: 9.9,
                  isPromote: true,
                  complements: []
                },
                quantity: 3,
                productId: 23267
              },
              {
                obs: "",
                name: "X-Tudo",
                type: "default",
                details: {
                  value: 9.9,
                  isPromote: true,
                  complements: []
                },
                quantity: 1,
                productId: 23268
              }
            ],
            code: 7092,
            type: "D",
            total: 39.6,
            status: null,
            cupomId: null,
            clientId: 56,
            controls: {},
            addressId: null,
            cartPizza: [],
            cashierId: null,
            commandId: null,
            profileId: 1,
            created_at: "2023-07-19 14:34:57",
            updated_at: "2023-07-19 14:34:57",
            packageDate: null,
            taxDelivery: 0,
            timeDelivery: 0
          },
          {
            id: 7054258,
            cart: [
              {
                obs: "",
                name: "X-Salada Duplo",
                type: "default",
                details: {
                  value: 9.9,
                  isPromote: true,
                  complements: [
                    {
                      id: 1,
                      max: 10,
                      min: 0,
                      name: "Turbine seu Lanche",
                      itens: [
                        {
                          code: "40df65",
                          name: "carne extra",
                          value: 5,
                          status: true,
                          quantity: 1,
                          description: ""
                        },
                        {
                          code: "ce5251",
                          name: "bacon",
                          value: 2,
                          status: true,
                          quantity: 1,
                          description: ""
                        }
                      ],
                      required: 0
                    }
                  ]
                },
                quantity: 1,
                productId: 92880
              },
              {
                obs: "",
                name: "X-Salada Duplo",
                type: "default",
                details: {
                  value: 9.9,
                  isPromote: true,
                  complements: []
                },
                quantity: 1,
                productId: 92880
              },
              {
                obs: "",
                name: "X-Salada Duplo",
                type: "default",
                details: {
                  value: 9.9,
                  isPromote: true,
                  complements: []
                },
                quantity: 2,
                productId: 92880
              },
              {
                obs: "Sem tomate por favor",
                name: "X-Tudo",
                type: "default",
                details: {
                  value: 9.9,
                  isPromote: true,
                  complements: []
                },
                quantity: 1,
                productId: 23268
              }
            ],
            code: 7091,
            type: "D",
            total: 0,
            status: null,
            cupomId: null,
            clientId: 56,
            controls: {},
            addressId: null,
            cartPizza: [
              {
                obs: "",
                name: "Pizza Grande 2 Sabores Atum,Frango com Catupiry ",
                type: "pizza",
                details: {
                  value: 44,
                  flavors: [
                    {
                      code: "53e5e0",
                      name: "Atum",
                      image: "https://s3.us-west-2.amazonaws.com/whatsmenu/production/restaurantbrazil/pizza-products/53e5e0/4.jpg",
                      status: true,
                      values: {
                        Broto: 15,
                        Grande: 30
                      },
                      schedule: {
                        type: 0
                      },
                      complements: [],
                      description: "Molho, mussarela, atum, or\xE9gano e azeitonas",
                      valuesTable: {
                        Broto: 15,
                        Grande: 30
                      },
                      disponibility: {
                        store: "full"
                      },
                      implementations: []
                    },
                    {
                      code: "a0b3c5",
                      name: "Frango com Catupiry",
                      image: "https://s3.us-west-2.amazonaws.com/whatsmenu/production/restaurantbrazil/pizza-products/a0b3c5/4.jpeg",
                      status: true,
                      values: {
                        Broto: 22,
                        Grande: 44
                      },
                      schedule: {
                        type: 0
                      },
                      complements: [],
                      description: "Molho, mussarela, frango, catupiry original, or\xE9gano e azeitonas",
                      valuesTable: {
                        Broto: 22,
                        Grande: 44
                      },
                      disponibility: {
                        store: "full"
                      },
                      implementations: []
                    }
                  ],
                  sizeCode: "4a248f",
                  complements: [],
                  implementations: []
                },
                pizzaId: 1679,
                quantity: 1
              },
              {
                obs: "",
                name: "Pizza Broto 1 Sabor Quatro Queijos com Borda de Catupiry",
                type: "pizza",
                details: {
                  value: 22,
                  flavors: [
                    {
                      code: "a0dbd2",
                      name: "Quatro Queijos",
                      image: "https://s3.us-west-2.amazonaws.com/whatsmenu/production/restaurantbrazil/pizza-products/a0dbd2/4.jpeg",
                      status: true,
                      values: {
                        Broto: 22,
                        Grande: 44
                      },
                      schedule: {
                        type: 0
                      },
                      complements: [],
                      description: "Mussarela, catupiry, gorgonzola e parmes\xE3o",
                      valuesTable: {
                        Broto: 22,
                        Grande: 44
                      },
                      disponibility: {
                        store: "full"
                      },
                      implementations: []
                    }
                  ],
                  sizeCode: "a31eb3",
                  complements: [],
                  implementations: [
                    {
                      code: "cf2e08",
                      name: "Borda de Catupiry",
                      value: 5,
                      status: true
                    }
                  ]
                },
                pizzaId: 1679,
                quantity: 1
              }
            ],
            cashierId: null,
            commandId: null,
            profileId: 1,
            created_at: "2023-07-19 14:26:43",
            updated_at: "2023-07-19 14:26:43",
            packageDate: null,
            taxDelivery: 0,
            timeDelivery: 0
          },
          {
            id: 7054257,
            cart: [
              {
                obs: "",
                name: "X-Salada Duplo",
                type: "default",
                details: {
                  value: 9.9,
                  isPromote: true,
                  complements: [
                    {
                      id: 1,
                      max: 10,
                      min: 0,
                      name: "Turbine seu Lanche",
                      itens: [
                        {
                          code: "40df65",
                          name: "carne extra",
                          value: 5,
                          status: true,
                          quantity: 1,
                          description: ""
                        },
                        {
                          code: "ce5251",
                          name: "bacon",
                          value: 2,
                          status: true,
                          quantity: 1,
                          description: ""
                        }
                      ],
                      required: 0
                    }
                  ]
                },
                quantity: 1,
                productId: 92880
              },
              {
                obs: "",
                name: "X-Salada Duplo",
                type: "default",
                details: {
                  value: 9.9,
                  isPromote: true,
                  complements: []
                },
                quantity: 1,
                productId: 92880
              },
              {
                obs: "",
                name: "X-Salada Duplo",
                type: "default",
                details: {
                  value: 9.9,
                  isPromote: true,
                  complements: []
                },
                quantity: 2,
                productId: 92880
              },
              {
                obs: "Sem tomate por favor",
                name: "X-Tudo",
                type: "default",
                details: {
                  value: 9.9,
                  isPromote: true,
                  complements: []
                },
                quantity: 1,
                productId: 23268
              }
            ],
            code: 7090,
            type: "D",
            total: 0,
            status: null,
            cupomId: null,
            clientId: 56,
            controls: {},
            addressId: null,
            cartPizza: [
              {
                obs: "",
                name: "Pizza Grande 2 Sabores Atum,Frango com Catupiry ",
                type: "pizza",
                details: {
                  value: 44,
                  flavors: [
                    {
                      code: "53e5e0",
                      name: "Atum",
                      image: "https://s3.us-west-2.amazonaws.com/whatsmenu/production/restaurantbrazil/pizza-products/53e5e0/4.jpg",
                      status: true,
                      values: {
                        Broto: 15,
                        Grande: 30
                      },
                      schedule: {
                        type: 0
                      },
                      complements: [],
                      description: "Molho, mussarela, atum, or\xE9gano e azeitonas",
                      valuesTable: {
                        Broto: 15,
                        Grande: 30
                      },
                      disponibility: {
                        store: "full"
                      },
                      implementations: []
                    },
                    {
                      code: "a0b3c5",
                      name: "Frango com Catupiry",
                      image: "https://s3.us-west-2.amazonaws.com/whatsmenu/production/restaurantbrazil/pizza-products/a0b3c5/4.jpeg",
                      status: true,
                      values: {
                        Broto: 22,
                        Grande: 44
                      },
                      schedule: {
                        type: 0
                      },
                      complements: [],
                      description: "Molho, mussarela, frango, catupiry original, or\xE9gano e azeitonas",
                      valuesTable: {
                        Broto: 22,
                        Grande: 44
                      },
                      disponibility: {
                        store: "full"
                      },
                      implementations: []
                    }
                  ],
                  sizeCode: "4a248f",
                  complements: [],
                  implementations: []
                },
                pizzaId: 1679,
                quantity: 1
              },
              {
                obs: "",
                name: "Pizza Broto 1 Sabor Quatro Queijos com Borda de Catupiry",
                type: "pizza",
                details: {
                  value: 22,
                  flavors: [
                    {
                      code: "a0dbd2",
                      name: "Quatro Queijos",
                      image: "https://s3.us-west-2.amazonaws.com/whatsmenu/production/restaurantbrazil/pizza-products/a0dbd2/4.jpeg",
                      status: true,
                      values: {
                        Broto: 22,
                        Grande: 44
                      },
                      schedule: {
                        type: 0
                      },
                      complements: [],
                      description: "Mussarela, catupiry, gorgonzola e parmes\xE3o",
                      valuesTable: {
                        Broto: 22,
                        Grande: 44
                      },
                      disponibility: {
                        store: "full"
                      },
                      implementations: []
                    }
                  ],
                  sizeCode: "a31eb3",
                  complements: [],
                  implementations: [
                    {
                      code: "cf2e08",
                      name: "Borda de Catupiry",
                      value: 5,
                      status: true
                    }
                  ]
                },
                pizzaId: 1679,
                quantity: 1
              }
            ],
            cashierId: null,
            commandId: null,
            profileId: 1,
            created_at: "2023-07-19 14:24:57",
            updated_at: "2023-07-19 14:24:57",
            packageDate: null,
            taxDelivery: 0,
            timeDelivery: 0
          },
          {
            id: 7054256,
            cart: [
              {
                obs: "",
                name: "X-Salada Duplo",
                type: "default",
                details: {
                  value: 9.9,
                  isPromote: true,
                  complements: [
                    {
                      id: 1,
                      max: 10,
                      min: 0,
                      name: "Turbine seu Lanche",
                      itens: [
                        {
                          code: "40df65",
                          name: "carne extra",
                          value: 5,
                          status: true,
                          quantity: 1,
                          description: ""
                        },
                        {
                          code: "ce5251",
                          name: "bacon",
                          value: 2,
                          status: true,
                          quantity: 1,
                          description: ""
                        }
                      ],
                      required: 0
                    }
                  ]
                },
                quantity: 1,
                productId: 92880
              },
              {
                obs: "",
                name: "X-Salada Duplo",
                type: "default",
                details: {
                  value: 9.9,
                  isPromote: true,
                  complements: []
                },
                quantity: 1,
                productId: 92880
              },
              {
                obs: "",
                name: "X-Salada Duplo",
                type: "default",
                details: {
                  value: 9.9,
                  isPromote: true,
                  complements: []
                },
                quantity: 2,
                productId: 92880
              },
              {
                obs: "Sem tomate por favor",
                name: "X-Tudo",
                type: "default",
                details: {
                  value: 9.9,
                  isPromote: true,
                  complements: []
                },
                quantity: 1,
                productId: 23268
              }
            ],
            code: 7089,
            type: "D",
            total: 0,
            status: null,
            cupomId: null,
            clientId: 56,
            controls: {},
            addressId: null,
            cartPizza: [
              {
                obs: "",
                name: "Pizza Grande 2 Sabores Atum,Frango com Catupiry ",
                type: "pizza",
                details: {
                  value: 44,
                  flavors: [
                    {
                      code: "53e5e0",
                      name: "Atum",
                      image: "https://s3.us-west-2.amazonaws.com/whatsmenu/production/restaurantbrazil/pizza-products/53e5e0/4.jpg",
                      status: true,
                      values: {
                        Broto: 15,
                        Grande: 30
                      },
                      schedule: {
                        type: 0
                      },
                      complements: [],
                      description: "Molho, mussarela, atum, or\xE9gano e azeitonas",
                      valuesTable: {
                        Broto: 15,
                        Grande: 30
                      },
                      disponibility: {
                        store: "full"
                      },
                      implementations: []
                    },
                    {
                      code: "a0b3c5",
                      name: "Frango com Catupiry",
                      image: "https://s3.us-west-2.amazonaws.com/whatsmenu/production/restaurantbrazil/pizza-products/a0b3c5/4.jpeg",
                      status: true,
                      values: {
                        Broto: 22,
                        Grande: 44
                      },
                      schedule: {
                        type: 0
                      },
                      complements: [],
                      description: "Molho, mussarela, frango, catupiry original, or\xE9gano e azeitonas",
                      valuesTable: {
                        Broto: 22,
                        Grande: 44
                      },
                      disponibility: {
                        store: "full"
                      },
                      implementations: []
                    }
                  ],
                  sizeCode: "4a248f",
                  complements: [],
                  implementations: []
                },
                pizzaId: 1679,
                quantity: 1
              },
              {
                obs: "",
                name: "Pizza Broto 1 Sabor Quatro Queijos com Borda de Catupiry",
                type: "pizza",
                details: {
                  value: 22,
                  flavors: [
                    {
                      code: "a0dbd2",
                      name: "Quatro Queijos",
                      image: "https://s3.us-west-2.amazonaws.com/whatsmenu/production/restaurantbrazil/pizza-products/a0dbd2/4.jpeg",
                      status: true,
                      values: {
                        Broto: 22,
                        Grande: 44
                      },
                      schedule: {
                        type: 0
                      },
                      complements: [],
                      description: "Mussarela, catupiry, gorgonzola e parmes\xE3o",
                      valuesTable: {
                        Broto: 22,
                        Grande: 44
                      },
                      disponibility: {
                        store: "full"
                      },
                      implementations: []
                    }
                  ],
                  sizeCode: "a31eb3",
                  complements: [],
                  implementations: [
                    {
                      code: "cf2e08",
                      name: "Borda de Catupiry",
                      value: 5,
                      status: true
                    }
                  ]
                },
                pizzaId: 1679,
                quantity: 1
              }
            ],
            cashierId: null,
            commandId: null,
            profileId: 1,
            created_at: "2023-07-19 14:10:15",
            updated_at: "2023-07-19 14:10:15",
            packageDate: null,
            taxDelivery: 0,
            timeDelivery: 0
          },
          {
            id: 7054255,
            cart: [
              {
                obs: "",
                name: "X-Salada Duplo",
                type: "default",
                details: {
                  value: 9.9,
                  isPromote: true,
                  complements: [
                    {
                      id: 1,
                      max: 10,
                      min: 0,
                      name: "Turbine seu Lanche",
                      itens: [
                        {
                          code: "40df65",
                          name: "carne extra",
                          value: 5,
                          status: true,
                          quantity: 1,
                          description: ""
                        },
                        {
                          code: "ce5251",
                          name: "bacon",
                          value: 2,
                          status: true,
                          quantity: 1,
                          description: ""
                        }
                      ],
                      required: 0
                    }
                  ]
                },
                quantity: 1,
                productId: 92880
              },
              {
                obs: "",
                name: "X-Salada Duplo",
                type: "default",
                details: {
                  value: 9.9,
                  isPromote: true,
                  complements: []
                },
                quantity: 1,
                productId: 92880
              },
              {
                obs: "",
                name: "X-Salada Duplo",
                type: "default",
                details: {
                  value: 9.9,
                  isPromote: true,
                  complements: []
                },
                quantity: 2,
                productId: 92880
              },
              {
                obs: "Sem tomate por favor",
                name: "X-Tudo",
                type: "default",
                details: {
                  value: 9.9,
                  isPromote: true,
                  complements: []
                },
                quantity: 1,
                productId: 23268
              }
            ],
            code: 7088,
            type: "D",
            total: 0,
            status: null,
            cupomId: null,
            clientId: 56,
            controls: {},
            addressId: null,
            cartPizza: [
              {
                obs: "",
                name: "Pizza Grande 2 Sabores Atum,Frango com Catupiry ",
                type: "pizza",
                details: {
                  value: 44,
                  flavors: [
                    {
                      code: "53e5e0",
                      name: "Atum",
                      image: "https://s3.us-west-2.amazonaws.com/whatsmenu/production/restaurantbrazil/pizza-products/53e5e0/4.jpg",
                      status: true,
                      values: {
                        Broto: 15,
                        Grande: 30
                      },
                      schedule: {
                        type: 0
                      },
                      complements: [],
                      description: "Molho, mussarela, atum, or\xE9gano e azeitonas",
                      valuesTable: {
                        Broto: 15,
                        Grande: 30
                      },
                      disponibility: {
                        store: "full"
                      },
                      implementations: []
                    },
                    {
                      code: "a0b3c5",
                      name: "Frango com Catupiry",
                      image: "https://s3.us-west-2.amazonaws.com/whatsmenu/production/restaurantbrazil/pizza-products/a0b3c5/4.jpeg",
                      status: true,
                      values: {
                        Broto: 22,
                        Grande: 44
                      },
                      schedule: {
                        type: 0
                      },
                      complements: [],
                      description: "Molho, mussarela, frango, catupiry original, or\xE9gano e azeitonas",
                      valuesTable: {
                        Broto: 22,
                        Grande: 44
                      },
                      disponibility: {
                        store: "full"
                      },
                      implementations: []
                    }
                  ],
                  sizeCode: "4a248f",
                  complements: [],
                  implementations: []
                },
                pizzaId: 1679,
                quantity: 1
              },
              {
                obs: "",
                name: "Pizza Broto 1 Sabor Quatro Queijos com Borda de Catupiry",
                type: "pizza",
                details: {
                  value: 22,
                  flavors: [
                    {
                      code: "a0dbd2",
                      name: "Quatro Queijos",
                      image: "https://s3.us-west-2.amazonaws.com/whatsmenu/production/restaurantbrazil/pizza-products/a0dbd2/4.jpeg",
                      status: true,
                      values: {
                        Broto: 22,
                        Grande: 44
                      },
                      schedule: {
                        type: 0
                      },
                      complements: [],
                      description: "Mussarela, catupiry, gorgonzola e parmes\xE3o",
                      valuesTable: {
                        Broto: 22,
                        Grande: 44
                      },
                      disponibility: {
                        store: "full"
                      },
                      implementations: []
                    }
                  ],
                  sizeCode: "a31eb3",
                  complements: [],
                  implementations: [
                    {
                      code: "cf2e08",
                      name: "Borda de Catupiry",
                      value: 5,
                      status: true
                    }
                  ]
                },
                pizzaId: 1679,
                quantity: 1
              }
            ],
            cashierId: null,
            commandId: null,
            profileId: 1,
            created_at: "2023-07-19 14:06:17",
            updated_at: "2023-07-19 14:06:17",
            packageDate: null,
            taxDelivery: 0,
            timeDelivery: 0
          }
        ],
        controls: {},
        date_last_request: "2023-07-19T17:58:54.000Z",
        deleted_at: null,
        created_at: "2023-06-26 12:47:36",
        updated_at: "2023-07-19 14:58:54"
      },
      cashier: null,
      sendMB: false
    };
    return new _Cart(cartPrintTest);
  }
  /**
   * Creates a Cart instance from an Ifood order and a profile.
   *
   * @param {IfoodOrderType} order - The Ifood order object
   * @param {Profile | ProfileType} profile - The profile associated with the order
   * @return {Cart} A new Cart instance created from the Ifood order and profile
   */
  static fromIfood({
    order,
    profile
  }) {
    let type;
    let address;
    let taxIfood = 0;
    let cupom;
    let status;
    let motoboy;
    let motoboyId;
    if (order?.orderTiming === "IMMEDIATE" || order?.orderType === "TAKEOUT") {
      type = "D";
    }
    console.log(order, "ORDER CHEGOU BY IFOOD");
    if (order?.orderTiming === "SCHEDULED") {
      type = "P";
    }
    if (order?.orderType === "TAKEOUT") {
      address = null;
    }
    if (order.additionalInfo?.motoboy) {
      motoboy = order.additionalInfo.motoboy;
      motoboyId = order.additionalInfo.motoboy.id;
    }
    if (order.orderType === "DELIVERY") {
      address = {
        city: order.delivery.deliveryAddress.city,
        neighborhood: order.delivery.deliveryAddress.neighborhood,
        street: order.delivery.deliveryAddress.streetName,
        number: order.delivery.deliveryAddress.streetNumber,
        complement: order.delivery.deliveryAddress.complement,
        reference: order.delivery.deliveryAddress.reference,
        zipcode: order.delivery.deliveryAddress.postalCode,
        latitude: order.delivery.deliveryAddress.coordinates.latitude,
        longitude: order.delivery.deliveryAddress.coordinates.longitude,
        uf: order.delivery.deliveryAddress.state
      };
    }
    if (order.total.additionalFees) {
      taxIfood = order.total.additionalFees;
    }
    if (order.total.benefits) {
      cupom = {
        value: order.total.benefits,
        type: "value"
      };
    }
    switch (order.orderStatus) {
      case "PREPARATION_STARTED":
        status = "production";
        break;
      case "CONCLUDED":
      case "DISPATCHED":
      case "READY_TO_PICKUP":
        status = "transport";
        break;
      case "CANCELLED":
        status = "canceled";
        break;
      default:
        status = null;
        break;
    }
    const ifoodCart = {
      id: order.id,
      orderId: order.orderId,
      origin: "ifood",
      ifoodStatus: order.orderStatus,
      ifoodAditionalInfo: order.additionalInfo,
      obs: order.extraInfo,
      address,
      print: order.additionalInfo?.print || 0 || 1,
      profileId: profile.id,
      code: order.displayId,
      taxIfood,
      cupom,
      motoboy: motoboy ?? null,
      motoboyId: motoboyId ?? null,
      client: {
        name: order.customer.name,
        whatsapp: order.customer.phone.number ?? "Prote\xE7\xE3o de Privacidade",
        codeLocalizer: order.customer.phone?.localizer ? order.customer.phone.localizer : order.customer.phone.number
      },
      clientId: 999,
      secretNumber: order.customer.secretNumber ? order.customer.secretNumber : "",
      status,
      type,
      taxDelivery: order.total.deliveryFee,
      timeDelivery: order.delivery ? order.delivery.deliveryDateTime : "0",
      formsPayment: order.payments.map((formPayment, index) => {
        let payment = "others";
        let label = "Outros";
        for (formPayment of formPayment.methods) {
          switch (formPayment.method) {
            case "CASH":
              payment = "money";
              label = "Dinheiro";
              break;
            case "CREDIT":
              payment = "credit";
              label = "Cr\xE9dito";
              break;
            case "DEBIT":
              payment = "debit";
              label = "D\xE9bito";
              break;
            case "MEAL_VOUCHER":
              payment = "snack";
              label = "Vale Refei\xE7\xE3o";
              break;
            case `FOOD_VOUCHER`:
              payment = "food";
              label = "Vale Alimenta\xE7\xE3o";
              break;
            case "GIFT_CARD":
              payment = "gift_card";
              label = "Gift Card";
              break;
            case "DIGITAL_WALLET":
              payment = "digital_wallet";
              label = "Carteira Digital";
              break;
            case "PIX":
              payment = "pix";
              label = "Pix";
              break;
            default:
              payment = "others";
              label = "Outros";
          }
        }
        return {
          flag: formPayment.card?.brand ?? null,
          change: formPayment.cash ? formPayment.cash?.changeFor : null,
          label,
          value: formPayment.value,
          payment
        };
      }),
      tentatives: 0,
      total: order.total.subTotal,
      totalPaid: order.total.orderAmount,
      controls: {
        ifood: {
          pickupCode: order.delivery ? order.delivery.pickupCode : null
        }
      },
      statusPayment: order.payments.flatMap((payment) => payment.methods).some(
        (method) => method.type === "OFFLINE"
      ) ? "offline" : "paid",
      packageDate: luxon.DateTime.fromISO(order.additionalInfo?.schedule?.deliveryDateTimeEnd, {
        zone: profile.timeZone
      }) || null,
      created_at: luxon.DateTime.fromISO(order.createdAt).toSQL(),
      updated_at: order.updatedAt,
      itens: order.itens.map((item) => ({
        cartId: order.id,
        controls: {},
        created_at: luxon.DateTime.fromISO(item.createdAt).toSQL(),
        updated_at: luxon.DateTime.fromISO(item.updatedAt).toSQL(),
        id: item.id,
        name: item.name,
        quantity: item.quantity,
        productId: item.uniqueId,
        pizzaId: null,
        type: "default",
        obs: item.observations || "",
        details: {
          complements: item.complements?.reduce((acc, complement) => {
            if (!complement.groupName) {
              complement.groupName = "Complementos";
            }
            const repeatedGroup = acc.findIndex(
              (group) => group.name === complement.groupName
            );
            if (repeatedGroup !== -1) {
              acc[repeatedGroup].itens.push({
                name: complement.name,
                quantity: complement.quantity,
                value: complement.unitPrice,
                status: true
              });
            } else {
              acc.push({
                name: complement.groupName,
                type: "default",
                itens: [
                  {
                    name: complement.name,
                    quantity: complement.quantity,
                    value: complement.unitPrice,
                    status: true
                  }
                ]
              });
            }
            return acc;
          }, []) ?? [],
          flavors: [],
          implementations: [],
          value: item.unitPrice
        }
      }))
    };
    return new _Cart(ifoodCart);
  }
  static fromKeeta({
    order,
    profile,
    customer,
    items
  }) {
    let type;
    let address;
    switch (order.order_timing) {
      case "INSTANT":
      case "instant":
      case "ONDEMAND":
      case "ondemand":
        type = "D";
        break;
      case "SCHEDULED":
      case "scheduled":
        type = "P";
        break;
      default:
        type = "D";
    }
    if (order.type === "TAKEOUT" || order.type === "INDOOR") {
      address = null;
    }
    if ((order.type === "DELIVERY" || order.type === "delivery") && order.delivery) {
      address = {
        city: order.delivery.deliveryAddress.city,
        neighborhood: order.delivery.deliveryAddress.neighborhood,
        street: order.delivery.deliveryAddress.streetName,
        number: order.delivery.deliveryAddress.streetNumber,
        complement: order.delivery.deliveryAddress.complement,
        reference: order.delivery.deliveryAddress.reference,
        zipcode: order.delivery.deliveryAddress.postalCode,
        latitude: order.delivery.deliveryAddress.coordinates?.latitude,
        longitude: order.delivery.deliveryAddress.coordinates?.longitude,
        uf: order.delivery.deliveryAddress.state
      };
    }
    let status;
    switch (order.last_event) {
      case "CONFIRMED":
        status = "production";
        break;
      case "DISPATCHED":
      case "READY_FOR_PICKUP":
      case "PICKED_UP":
        status = "transport";
        break;
      case "DELIVERED":
        status = "delivered";
        break;
      case "CANCELLED":
      case "CANCELLATION_REQUESTED":
        status = "canceled";
        break;
      case "CONCLUDED":
      case "USER_REFUND_REQUEST":
      case "REFUNDED":
      case "REFUND_FAILED":
        status = "delivered";
        break;
      default:
        status = null;
        break;
    }
    const keetaCart = {
      id: order.id,
      orderId: String(order.order_id),
      origin: "keeta",
      obs: order.extra_info,
      address,
      print: 1,
      motoboy: order.controls?.motoboy,
      motoboyId: order.controls?.motoboy.id,
      profileId: profile.id,
      code: order.display_id,
      taxDelivery: order.delivery?.deliveryFee || order.other_fees?.find((fee) => fee.type === "DELIVERY_FEE")?.price.value || 0,
      cupom: order.discounts ? {
        value: order.discounts.reduce((acc, d) => {
          return acc += Number(d.amount.value);
        }, 0),
        minValue: 0,
        status: 1,
        type: "value",
        code: "PROMO\xC7\xC3O-KEETA"
      } : void 0,
      client: {
        name: customer?.name,
        whatsapp: customer?.phone.extension + customer?.phone.number
      },
      clientId: order.customer_id,
      secretNumber: order.tax_invoice?.document_number,
      status,
      type,
      timeDelivery: "0",
      formsPayment: order.payments.methods.map((method) => {
        let payment;
        switch (method.method.toLowerCase()) {
          case "credit":
            payment = "credit";
            break;
          case "debit":
            payment = "debit";
            break;
          case "meal_voucher":
            payment = "snack";
            break;
          case "food_voucher":
            payment = "food";
            break;
          case "pix":
            payment = "pix";
            break;
          case "cash":
            payment = "money";
            break;
          default:
            payment = "others";
        }
        return {
          label: method.method,
          payment,
          value: parseFloat(method.value),
          change: method.cash?.change,
          paid: method.type === "PAID" || method.type === "PREPAID"
        };
      }),
      tentatives: 0,
      total: order.payments.prepaid + order.payments.pending,
      controls: {},
      statusPayment: order.payments.methods.some(
        (p) => p.status === "PAID"
      ) ? "paid" : "offline",
      packageDate: order.schedule?.delivery_date_time_end ? luxon.DateTime.fromSeconds(order.schedule.delivery_date_time_end).toSQL() : null,
      created_at: luxon.DateTime.fromISO(order.created_at).toSQL(),
      updated_at: luxon.DateTime.fromISO(order.updated_at).toSQL(),
      itens: items?.map(
        (item) => ({
          id: item.id,
          cartId: order.id,
          productId: item.item_id,
          pizzaId: null,
          type: "default",
          quantity: item.quantity,
          obs: item.special_instructions || "",
          name: item.product_name,
          controls: {},
          created_at: luxon.DateTime.fromISO(item.created_at).toSQL(),
          updated_at: luxon.DateTime.fromISO(item.updated_at).toSQL(),
          details: {
            value: parseFloat(item.unit_price.value),
            complements: item.complements?.options?.map((option) => ({
              name: option.name,
              quantity: option.quantity,
              value: parseFloat(option.unit_price),
              status: true
            })) || [],
            flavors: [],
            implementations: []
          }
        })
      )
    };
    return new _Cart(keetaCart);
  }
  static fromNineNine({
    order,
    profile,
    customer,
    items
  }) {
    let type = "D";
    type = "D";
    let address = void 0;
    if (order.receive_address) {
      const a = order.receive_address;
      address = {
        city: a.city,
        neighborhood: a.district,
        street: a.street_name || a.poi_display_name,
        number: a.street_number || a.house_number || null,
        complement: a.complement,
        reference: a.reference,
        zipcode: a.postal_code,
        latitude: a.poi_lat,
        longitude: a.poi_lng,
        uf: a.state
      };
    }
    const centsToReal = (v) => typeof v === "number" ? Number((v / 100).toFixed(2)) : 0;
    let status = null;
    switch (order.event_type) {
      case "orderCancel":
        status = "canceled";
        break;
      case "orderFinish":
        status = "delivered";
        break;
      case "deliveryStatus":
        status = "transport";
        break;
      default:
        status = null;
        break;
    }
    if (order.status) {
      switch (order.status) {
        case NineNineFoodOrderStatus.CANCELLED_BY_99FOOD_SERVICE:
        case NineNineFoodOrderStatus.CANCELLED_BY_CUSTOMER_1:
        case NineNineFoodOrderStatus.CANCELLED_BY_CUSTOMER_2:
        case NineNineFoodOrderStatus.CANCELLED_BY_STORE_1:
        case NineNineFoodOrderStatus.CANCELLED_BY_STORE_2:
        case NineNineFoodOrderStatus.CANCELLED_BY_COURIER_1:
        case NineNineFoodOrderStatus.CANCELLED_BY_COURIER_2:
          status = "canceled";
          break;
        case NineNineFoodOrderStatus.ORDER_FINISHED:
          status = "delivered";
          break;
        case NineNineFoodOrderStatus.ORDER_ACCEPTED:
          status = "production";
          break;
        case NineNineFoodOrderStatus.READY_FOR_PICKUP:
        case NineNineFoodOrderStatus.RIDER_TOOK_ORDER:
          status = "transport";
          break;
        // case "":
        //   status = "transport";
        //   break;
        default: {
          if (order.event_type === "deliveryStatus") {
            status = "transport";
          } else {
            status = null;
          }
          break;
        }
      }
    } else {
      if (order.cancel_time) {
        status = "canceled";
      } else if (order.complete_time) {
        status = "delivered";
      } else if (order.shop_confirm_time) {
        status = "production";
      } else {
        status = null;
      }
    }
    const cupom = order.promotions && order.promotions.length > 0 ? {
      value: centsToReal(
        order.promotions.reduce(
          (acc, p) => acc + (p.promo_discount || 0),
          0
        )
      ),
      minValue: 0,
      status: 1,
      type: "value",
      code: "PROMOCAO-99"
    } : void 0;
    let formsPayment = [];
    switch (String(order.pay_type)) {
      case "1":
        formsPayment = [
          {
            label: "Pagamento Online",
            payment: "credit",
            value: centsToReal(order.price?.order_price) || 0,
            change: void 0,
            paid: !!order.pay_time,
            addon: { status: false, type: "fee", valueType: "fixed", value: 0 }
          }
        ];
        break;
      case "2":
        formsPayment = [
          {
            label: "Dinheiro",
            payment: "money",
            value: centsToReal(order.price?.order_price) || 0,
            change: centsToReal(order.change_for) || 0,
            paid: !!order.pay_time,
            addon: { status: false, type: "fee", valueType: "fixed", value: 0 }
          }
        ];
        break;
      case "3":
        formsPayment = [
          {
            label: "M\xE1quina de Cart\xE3o",
            payment: "debit",
            value: centsToReal(order.price?.order_price) || 0,
            change: void 0,
            paid: !!order.pay_time,
            addon: { status: false, type: "fee", valueType: "fixed", value: 0 }
          }
        ];
        break;
      case "4":
        formsPayment = [
          {
            label: "99Pay",
            payment: "others",
            value: centsToReal(order.price?.order_price) || 0,
            change: void 0,
            paid: !!order.pay_time,
            addon: { status: false, type: "fee", valueType: "fixed", value: 0 }
          }
        ];
        break;
      case "5":
        formsPayment = [
          {
            label: "PayPay",
            payment: "others",
            value: centsToReal(order.price?.order_price) || 0,
            change: void 0,
            paid: !!order.pay_time,
            addon: { status: false, type: "fee", valueType: "fixed", value: 0 }
          }
        ];
        break;
      case "6":
        formsPayment = [
          {
            label: "PayPay com Senha",
            payment: "others",
            value: centsToReal(order.price?.order_price) || 0,
            change: void 0,
            paid: !!order.pay_time,
            addon: { status: false, type: "fee", valueType: "fixed", value: 0 }
          }
        ];
        break;
      default:
        formsPayment = [
          {
            label: "Outros",
            payment: "others",
            value: centsToReal(order.price?.order_price) || 0,
            change: void 0,
            paid: !!order.pay_time,
            addon: { status: false, type: "fee", valueType: "fixed", value: 0 }
          }
        ];
        break;
    }
    String(order.order_id);
    const nineCart = {
      id: Number(order.display_id),
      orderId: String(order.order_id),
      origin: "nine-nine",
      obs: order.remark || null,
      address,
      motoboy: order.receive_address?.motoboy || null,
      motoboyId: order.receive_address?.motoboy?.id || null,
      print: 1,
      profileId: profile.id,
      code: String(order.order_index),
      taxDelivery: centsToReal(order.price?.store_charged_delivery_price) || 0,
      cupom,
      client: {
        name: order.receive_address?.name || customer?.name,
        whatsapp: (order.customer?.phone.extension || " ") + (order.customer?.phone.number || " ")
      },
      clientId: order.receive_address?.uid || void 0,
      secretNumber: void 0,
      status,
      type,
      timeDelivery: String(order.delivery_eta || "0"),
      formsPayment,
      tentatives: 0,
      total: centsToReal(order.price?.order_price) || 0,
      controls: {
        nineNine: {
          handover_code: order.handover_code || null,
          delivery_type: order.delivery_type
        }
      },
      fees: [
        {
          automatic: true,
          type: "fixed",
          code: "Taxa de Servi\xE7o",
          value: centsToReal(order.price?.others_fees?.service_price) || 0,
          deliveryDisponibility: true,
          packageDisponibility: false,
          tableDisponibility: false,
          status: true,
          deleted_at: null
        }
      ],
      statusPayment: order.pay_method === 1 ? "paid" : "offline",
      packageDate: order.expected_arrived_eta ? luxon.DateTime.fromSeconds(order.expected_arrived_eta).toSQL() : null,
      created_at: order.create_time ? luxon.DateTime.fromSeconds(order.create_time).toSQL() : luxon.DateTime.now().toSQL(),
      updated_at: order.create_time ? luxon.DateTime.fromSeconds(order.create_time).toSQL() : luxon.DateTime.now().toSQL(),
      itens: (order.items || []).map((item) => {
        let parsedProductId = null;
        if (item.id) {
          if (typeof item.id === "number") {
            parsedProductId = item.id;
          } else {
            const num = Number(item.id);
            parsedProductId = isNaN(num) ? null : num;
          }
        }
        let realPrice = 0;
        if (item.total_price !== void 0 && item.total_price !== null) {
          if (typeof item.total_price === "string") {
            realPrice = Math.round(parseFloat(item.total_price));
          } else {
            realPrice = Math.round(item.total_price);
          }
        } else if (item.real_price !== void 0 && item.real_price !== null) {
          if (typeof item.real_price === "string") {
            realPrice = Math.round(parseFloat(item.real_price));
          } else {
            realPrice = Math.round(item.real_price);
          }
        }
        const complementsMap = /* @__PURE__ */ new Map();
        let totalComplementValue = 0;
        (item.sub_item_list || []).forEach((subItem) => {
          const groupName = subItem.content_name || "Complementos";
          if (!complementsMap.has(groupName)) {
            complementsMap.set(groupName, []);
          }
          let complementValue = 0;
          if (subItem.total_price !== void 0 && subItem.total_price !== null) {
            if (typeof subItem.total_price === "string") {
              complementValue = Math.round(parseFloat(subItem.total_price));
            } else {
              complementValue = Math.round(subItem.total_price);
            }
          } else if (subItem.sku_price !== void 0 && subItem.sku_price !== null) {
            if (typeof subItem.sku_price === "string") {
              complementValue = Math.round(parseFloat(subItem.sku_price));
            } else {
              complementValue = Math.round(subItem.sku_price);
            }
          }
          const complementAmount = subItem.amount || 1;
          totalComplementValue += complementValue * complementAmount;
          complementsMap.get(groupName).push({
            code: subItem.app_item_id || subItem.app_external_id || subItem.name || "",
            name: subItem.name || "",
            value: centsToReal(complementValue),
            // Mostra o valor do complemento
            status: true,
            description: "",
            quantity: complementAmount,
            amount: complementAmount,
            bypass_amount: false,
            amount_alert: 0
          });
        });
        const baseProductValue = Math.max(0, realPrice - totalComplementValue);
        const complements = Array.from(complementsMap.entries()).map(
          ([groupName, itens], index) => ({
            name: groupName,
            type: "default",
            order: index,
            min: 0,
            max: 999,
            required: false,
            itens
          })
        );
        return {
          id: item.id || 0,
          cartId: Number(order.order_id),
          productId: parsedProductId,
          pizzaId: null,
          type: "default",
          quantity: item.amount || 1,
          obs: item.remark || "",
          name: item.name || "",
          controls: { mdu_id: item.mdu_id },
          created_at: luxon.DateTime.now().toSQL(),
          updated_at: luxon.DateTime.now().toSQL(),
          details: {
            value: centsToReal(baseProductValue),
            // Valor base do produto sem os complementos
            complements,
            flavors: [],
            implementations: []
          }
        };
      })
    };
    return new _Cart(nineCart);
  }
};

// src/command.ts
var Command = class {
  id;
  tableOpenedId;
  clientId;
  opened;
  name;
  code;
  status;
  fees;
  formsPayment;
  carts;
  created_at;
  updated_at;
  totalPaid;
  // WS types only
  totalValue;
  subTotal;
  lack;
  paid;
  constructor(command) {
    this.id = command.id;
    this.tableOpenedId = command.tableOpenedId;
    this.clientId = command.clientId;
    this.opened = command.opened ? new TableOpened(command.opened) : void 0;
    this.status = command.status;
    this.name = command.name;
    this.code = command.code;
    this.fees = command.fees?.filter((fee) => fee.deleted_at === null);
    this.formsPayment = command.formsPayment;
    this.carts = command.carts?.map((cart) => new Cart(cart)) || [];
    this.created_at = command.created_at;
    this.updated_at = command.updated_at;
    this.totalPaid = Number(command.totalPaid) || 0;
  }
  haveCarts = () => {
    return !!this.carts.filter((cart) => cart.status !== "canceled").length;
  };
  getTotalValue = (only = "", value = 0) => {
    const commandTotal = this.carts.reduce(
      (commandTotal2, cart) => {
        if (cart.status !== "canceled") {
          commandTotal2 += cart.total;
        }
        return Number(Math.fround(commandTotal2).toFixed(2));
      },
      0
    );
    const feeTotal = this.fees.reduce((feeTotal2, fee) => {
      if (fee.status && fee.automatic) {
        if (fee.type === "percent") {
          feeTotal2 += fee.value / 100 * commandTotal;
        } else {
          feeTotal2 += fee.quantity ? fee.quantity * fee.value : 0;
        }
      }
      return Number(Math.fround(feeTotal2).toFixed(2));
    }, 0);
    const formsPaymentTotal = this.formsPayment.reduce(
      (formsPaymentTotal2, formPayment) => Number(Math.fround(formsPaymentTotal2 + formPayment.value).toFixed(2)),
      0
    );
    const total = commandTotal + feeTotal + formsPaymentTotal;
    switch (only) {
      case "":
        return total;
      case "fee":
        return feeTotal;
      case "commandFee":
        return commandTotal + feeTotal;
      case "formsPayment":
        return formsPaymentTotal;
      case "command":
        return commandTotal;
      case "lack":
        return Number(
          Math.fround(
            Math.min(commandTotal + feeTotal - formsPaymentTotal - value, 0)
          ).toFixed(2)
        );
      case "paid": {
        return Number(Math.fround(formsPaymentTotal + value).toFixed(2));
      }
    }
  };
  fullPaid = () => {
    return this.getTotalValue("paid") >= this.getTotalValue("commandFee");
  };
};

// src/table.ts
var Table = class {
  id;
  profileId;
  name;
  type;
  status;
  tablesOpened;
  opened;
  deleted_at;
  created_at;
  updated_at;
  constructor(table) {
    this.id = table.id;
    this.profileId = table.profileId;
    this.name = table.name;
    this.type = table.type;
    this.status = table.status;
    this.tablesOpened = table.tablesOpened?.map((t) => new TableOpened(t));
    this.opened = table.opened && new TableOpened(table.opened);
    this.deleted_at = table.deleted_at;
    this.created_at = table.created_at;
    this.updated_at = table.updated_at;
  }
  activeCommands = () => {
    return this.opened?.commands.filter((command) => command.status) ?? [];
  };
  haveCarts = () => {
    return !!this.activeCommands()?.some((command) => command.haveCarts());
  };
};
var TableOpened = class {
  id;
  tableId;
  table;
  status;
  fees;
  formsPayment;
  commands;
  perm;
  created_at;
  updated_at;
  // WS types only
  wsFormsPayment;
  wsPerm;
  updatedFees;
  totalValue;
  subTotal;
  lack;
  paid;
  constructor(tableOpened) {
    this.id = tableOpened.id;
    this.tableId = tableOpened.tableId;
    this.table = tableOpened.table ? new Table(tableOpened.table) : void 0;
    this.status = tableOpened.status;
    this.commands = tableOpened.commands ? tableOpened.commands.map((command) => new Command(command)) : [];
    this.fees = tableOpened.fees;
    this.formsPayment = tableOpened.formsPayment;
    this.perm = luxon.DateTime.fromISO(tableOpened.updated_at).diff(luxon.DateTime.fromISO(tableOpened.created_at), [
      "months",
      "days",
      "hours",
      "minutes"
    ]).toFormat(`hh'h'mm`);
    this.created_at = tableOpened.created_at;
    this.updated_at = tableOpened.updated_at;
  }
  // public allFormsPayment = () => {
  //   return this.formsPayment.concat(
  //     this.commands.flatMap(command => command.formsPayment)
  //   );
  // };
  allFeesById = (feeId) => {
    return this.commands.reduce((fees, command) => {
      const haveFee = command.fees.find((fee) => fee.id === feeId);
      if (haveFee) {
        fees.push(haveFee);
      }
      return fees;
    }, []);
  };
  getUpdatedFees = (filter = false, all = false) => {
    const fees = (filter ? this.commands.filter((c) => c.status) : this.commands).reduce((fees2, command) => {
      if (command.haveCarts()) {
        command.fees.forEach((fee) => {
          if (all ?? !fee.deleted_at) {
            const haveFee = fees2.find((f) => f.code === fee.code);
            if (!haveFee) {
              if (fee.quantity) {
                fee.quantity = fee.automatic ? fee.quantity : 0;
              }
              if (fee.type === "percent") {
                const tableFee = this.fees.find((f) => f.code === fee.code);
                if (tableFee) {
                  fee = tableFee;
                }
              }
              fees2.push({ ...fee });
            } else {
              if (fee.quantity && fee.type === "fixed") {
                haveFee.quantity += fee.automatic ? fee.quantity : 0;
              }
            }
          }
        });
      }
      return fees2;
    }, []);
    return fees;
  };
  getTotalValue = (only = "", value = 0, report = false) => {
    const tableTotal = this.commands.reduce((result, command) => {
      const paid = Number(command.totalPaid) || 0;
      return Number(Math.fround(result + paid).toFixed(2));
    }, 0);
    const totalValueTable = this.commands.flatMap((command) => command.carts).reduce((acc, cart) => acc + cart.getTotalValue("total"), 0);
    let feeTotal = this.getUpdatedFees(false, true).reduce((feeTotal2, fee) => {
      if (fee.status && fee.automatic) {
        if (fee.type === "percent") {
          feeTotal2 += fee.value / 100 * totalValueTable;
        } else {
          feeTotal2 += fee.quantity ? fee.quantity * fee.value : 0;
        }
      }
      return Number(Math.fround(feeTotal2).toFixed(2));
    }, 0);
    if (this.formsPayment?.some((form) => form.addon?.status)) {
      const addon = this.formsPayment.find((form) => form.addon?.status);
      if (addon) {
        switch (addon.addon.valueType) {
          case "fixed":
            if (addon.addon.type === "fee") {
              feeTotal += addon.addon.value;
            } else {
              feeTotal -= addon.addon.value;
            }
            break;
          case "percentage":
            if (addon.addon.type === "fee") {
              feeTotal += tableTotal * (addon.addon.value / 100);
            } else {
              feeTotal -= tableTotal * (addon.addon.value / 100);
            }
            break;
        }
      }
    }
    const total = tableTotal + feeTotal;
    let addonTotal = 0;
    if (this.formsPayment && this.formsPayment[0] && this.formsPayment[0].addon && this.formsPayment[0].addon.status) {
      const {
        type: addonType,
        value: addonValue,
        valueType: addonValueType
      } = this.formsPayment[0].addon;
      if (addonValueType === "percentage") {
        addonTotal = addonValue / 100 * (tableTotal + feeTotal);
      }
      if (addonValueType === "fixed") {
        addonTotal = addonValue;
      }
      if (addonType === "discount") {
        addonTotal = addonTotal * -1;
      }
    }
    switch (only) {
      case "":
        return total;
      case "addon":
        return addonTotal;
      case "fee":
        return feeTotal;
      case "tableFee": {
        return totalValueTable + feeTotal;
      }
      case "formsPayment":
        return tableTotal;
      case "table":
        return totalValueTable;
      case "lack":
        return Number(
          Math.fround(
            Math.max(tableTotal + feeTotal - value, 0)
          ).toFixed(2)
        );
      case "paid":
        return Number(Math.fround(tableTotal + value).toFixed(2));
    }
  };
  getCarts = () => {
    return this.commands.reduce((carts, command) => {
      command.carts.forEach((cart) => {
        carts.push(cart);
      });
      return carts;
    }, []);
  };
};

exports.Cart = Cart;
exports.Command = Command;
exports.Table = Table;
exports.TableOpened = TableOpened;
